export default [
  {
    path: "/dashboard",
    name: "dashboard-flyGate",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      resource: "Dashboard",
      action: "read",
    },
  },
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    component: () => import("@/views/dashboard/analytics/Analytics.vue"),
    meta: {
      resource: "DashboardAnalytics",
      action: "read",
    },
  },
  {
    path: "/dashboard/flyGate",
    name: "dashboard-ecommerce",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      resource: "DashboardEcommerce",
      action: "read",
    },
  },
];
